import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import HiddenUploadInput from '../../../components/common/HiddenUploadInput';
import SidebarPanelButton from '../../../components/common/SidebarPanelButton';
import useUploadImageAnnotation from '../../../hooks/useUploadImageAnnotation';
import { Upload } from '../../../utils/editorReactIcons';

const ImageUploadControl = ({ t }) => {
  const uploadInputRef = useRef(null);
  const { uploadImagesFromFiles, isUploading } = useUploadImageAnnotation();

  const handleUploadClick = () => {
    if (!isUploading) {
      uploadInputRef.current?.click();
    }
  };

  const handleUploadChange = (event) => {
    if (isUploading || !event.target.files?.length) {
      return;
    }
    uploadImagesFromFiles(event.target.files);
    event.target.value = '';
  };

  return (
    <>
      <SidebarPanelButton
        className="respark_image-upload-option respark_annotation-option-triggerer"
        Icon={Upload}
        label={
          isUploading ? t('uploadImageImporting') : t('uploadImageFromComputer')
        }
        title={t('uploadImageFromComputer')}
        disabled={isUploading}
        onClick={handleUploadClick}
      />
      <HiddenUploadInput
        ref={uploadInputRef}
        accept="image/*"
        disabled={isUploading}
        onChange={handleUploadChange}
      />
    </>
  );
};

ImageUploadControl.propTypes = {
  t: PropTypes.func.isRequired,
};

export default ImageUploadControl;
